import { connect } from 'react-redux';
import bvCurations from './bvCurations';

const mapStateToProps = ({ detailsPage }) => ({
  productCode: detailsPage.loadedProduct.productCode,
  htmlContent:
    (detailsPage.loadedProduct.contentSlotsHtml &&
      detailsPage.loadedProduct.contentSlotsHtml.UpperProductSpecificContent) ||
    '',
  content:
    detailsPage.loadedProduct.contentSlotsJson.UpperProductSpecificContent &&
    detailsPage.loadedProduct.contentSlotsJson.UpperProductSpecificContent.components
      ? detailsPage.loadedProduct.contentSlotsJson.UpperProductSpecificContent.components.find(
          item => item.type === 'BVContentCMSComponent'
        )
      : {},
});

export default connect(mapStateToProps)(bvCurations);
